import React from 'react'
import cx from 'classnames'
import { array } from 'helpers'

import caseImage from './images/case.png'
import flaskImage from './images/flask.png'


const images = {
  case: caseImage,
  flask: flaskImage,
} as const

export type ProductCountImageProps = {
  className?: string
  imageClassName?: string
  count: number
  imageType: keyof typeof images
}

const ProductCountImage: React.FunctionComponent<ProductCountImageProps> = (props) => {
  const { className, imageClassName, count, imageType } = props

  const finalImageClassName = cx(imageClassName, imageType === 'flask' ? 'mx-4' : 'mx-4 my-8')

  return (
    <div className={cx(className, 'flex justify-center')}>
      {
        array.range(1, count).map((_, index) => (
          <img
            key={index}
            className={finalImageClassName}
            src={images[imageType]}
            alt={imageType}
            draggable={false}
          />
        ))
      }
    </div>
  )
}


export default ProductCountImage
